<template>
  <div class="menubuilder__cselector">
    
    <h3>Our Coffees</h3>

    <ul class="menubuilder__coffeelist">
      <template v-if="selectedCoffees">
        <li class="menubuilder__coffee"  v-for="(coffee, index) in selectedCoffees" :key="index">
          <div class="ma__close" @click="$store.removeSelectedCoffee(coffee)">&times;</div>
          <h2 v-html="coffee.name" ></h2>
          <div class="menubuilder__description" v-html="coffee.description"></div>
        </li>
      </template>
      
      <li v-if="coffees && selectedCoffees.length < 2" class="menubuilder__coffee menubuilder__coffee--add" @click="toggleCoffeePopup">
        <span class="plus"><span>+</span></span>
        <span>Add the Matthew Algie coffee you serve (Max 2, {{ 2 - selectedCoffees.length }} left)</span>
      </li>
    </ul>

    <modal title="Select a coffee you stock" :isOpen="selectCoffeePopupOpen" @toggle="toggleCoffeePopup">
      <ul class="menubuilder__modallist">
        <li v-for="(coffee, index) in availableCoffees" :class="`${(coffee === preselectedCoffee) && 'selected'}`" :key="index" @click="preselectCoffee(coffee)">
          <h2 v-html="coffee.name" ></h2>
          <div class="menubuilder__description" v-html="coffee.description"></div>
        </li>
      </ul>
      <button :class="`menubuilder__addtomenu ${preselectedCoffee === undefined && 'menubuilder__addtomenu--disabled'}`" :disabled="preselectedCoffee === undefined" @click="selectCoffee()">Add to menu</button>
    </modal>

  </div>  
</template>

<script>
import Modal from '../Utilities/Modal.vue';
export default {
  components: { Modal },
  data() {
    return {
      coffees: this.$store.state.coffees,
      selectedCoffees: this.$store.state.selectedCoffees,
      selectCoffeePopupOpen: false,
      preselectedCoffee: undefined
    }
  },
  computed: {
    availableCoffees() {
      if(this.coffees) {
        return this.coffees.filter(coffee => !this.selectedCoffees.some(selected => selected === coffee));
      }
    }
  },
  methods: {
    toggleCoffeePopup() {
      this.selectCoffeePopupOpen = ! this.selectCoffeePopupOpen;
      const body = jQuery("body");

      if(body.css("overflow-y") !== "hidden") {
        jQuery("body").css("overflow-y", "hidden").css("height", "100vh");
      } else {
        jQuery("body").css("overflow-y", "inherit").css("height", "inherit");
      }
      
    },
    preselectCoffee(coffee) {
      this.preselectedCoffee = coffee
    },
    selectCoffee() {
      this.$store.addSelectedCoffee(this.preselectedCoffee)
      this.preselectedCoffee = undefined
      this.toggleCoffeePopup()
    }
  }
}
</script>

<style lang="sass">
@import "../../../../styles/partials/variables" 

.menubuilder
  &__cselector

  
  &__coffeelist
    padding: 0
    list-style: none

  &__coffee
    position: relative
    display: flex
    flex-flow: column
    padding: 15px
    margin-bottom: 15px
    @include helptext
    @include dotted-border
    cursor: pointer



    .ma__close 
      top: -23px
      right: -23px
      background: $color-white

    &--add
      padding: 30px
      justify-content: center
      align-items: center

    span.plus
      margin-bottom: 15px

  &__description
    color: $color-black
    font-size: 16px
    margin

  &__modallist 
    list-style: none
    padding: 0
    max-height: 70vh
    overflow-y: scroll

    li
      padding: 10px 30px
      border-radius: 7px
      border: 2px solid transparent
      cursor: pointer

      &:hover, &.selected 
        border: 2px solid #E3EACF
        background: #F0F4E7
  
  &__addtomenu 
    margin: 15px auto
    display: block
    outline: none
    border-width: 0
    text-transform: uppercase
    font-weight: 600 !important
    font-family: var( --e-global-typography-primary-font-family ), Sans-serif!important;
    background-color: $color-green !important

    &--disabled
      cursor: default
      background-color: lighten($color-green, 0%) !important

    &:hover
      background-color: $color-green-light !important

</style>


// WEBPACK FOOTER //
// resources/assets/scripts/vue/components/MenuBuilder/CoffeeSelector.vue